<div class="ks-card">
  <header class="ks-card-header">
    <div class="ks-card-header__title">
      <h1 class="ks-h1 ks-mb-0">Duplicate Cell Phone List</h1>
    </div>
    <div class="ks-card-header__tools">
      <button
        type="button"
        ktTooltip="Close"
        class="ks-btn-xs ks-btn-icon-round ks-btn-flat-neutral"
        (click)="close($event)"
      >
        <span inlineSVG="assets/icons/Close.svg"></span>
      </button>
    </div>
  </header>
  <main class="ks-card-body">
    <kt-table
      [columns]="columns"
      [loadItemsAction]="loadContactsList"
      [itemsSelector]="selectContacts"
      [itemsFilterSelector]="selectContactsFilter"
      [loadingSelector]="selectContactsListPageLoading"
      [resetItemsAction]="resetContactsListState"
    ></kt-table>
  </main>
</div>

<ng-template #idFilterRef let-control>
  <kt-input [type]="'text'" [label]="'ID'" [control]="control"></kt-input>
</ng-template>
<ng-template #usernameFilterRef let-control>
  <kt-input [type]="'text'" [label]="'Username'" [control]="control"></kt-input>
</ng-template>
<ng-template #contactRef let-control>
  <kt-input [type]="'text'" [label]="'Contact'" [control]="control"></kt-input>
</ng-template>
<ng-template #statusRef let-control>
  <div class="ks-badge-md ks-badge-light-{{ control.is_active ? 'tertiary' : 'danger' }}">
    {{ control.is_active ? 'Active' : 'Inactive' }}
  </div>
</ng-template>
<ng-template #cellPhoneFilterRef let-control let-index="index">
  <div class="ks-input-wrapper">
    <kt-input
      [type]="'tel'"
      [label]="'CellPhone'"
      [control]="getFormControl(index)"
      [mask]="'(000) 000-0000'"
    ></kt-input>
  </div>
</ng-template>

<ng-template #actionsRef let-control let-index="index">
  <button
    type="button"
    ktTooltip="Edit Cell Phone"
    class="ks-btn-sm ks-btn-icon-round ks-btn-flat-warning ks-mr-2"
    (click)="editContact(index)"
    [disabled]="getFormControl(index).invalid && getFormControl(index).dirty"
  >
    <span inlineSVG="assets/icons/Check.svg"></span>
  </button>

  <button
    type="button"
    ktTooltip="Cancel"
    class="ks-btn-sm ks-btn-icon-round ks-btn-flat-danger"
    (click)="resetCellPhone(index)"
  >
    <span inlineSVG="assets/icons/Close.svg"></span>
  </button>
</ng-template>
